// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__16sTh","label":"LabeledBox_label__3aswO"};